export enum STATUS {
	Failed = 'failed',
	DataRequested = 'data_requested',
	Generated = 'generated',
	Expired = 'expired',
	Created = 'created',
}

export enum TRANSACTION_STATUS {
	FAILED = 'failed',
	SIGNED = 'signed',
	CREATED = 'created',
	UNSIGNED = 'unsigned',
	EXECUTED = 'executed',
}

export enum VOP_STATUS {
	MATCH = 'MATCH',
	CLOSE_MATCH = 'CLOSE_MATCH',
	NO_MATCH = 'NO_MATCH',
	CANNOT_VERIFY = 'CANNOT_VERIFY',
}

export enum CC_FEATURE_FLAGS {
	DEVICE_LIST = 'CS-1446-device-list',
	ADDRESS_ALIGNMENT = 'BT-996-structured-addresses-in-ib-payments',
	WITH_RESTRICTED_IBANS = 'CS-1488-iban-access',
	LEGAL_CONSENT_SCREEN = 'CS-1584-legal-consent-screen',
}
